module.exports = __webpack_public_path__ + "static/media/imagen-estadistica.accbebfa.png";